'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _components = require('components');

var _moduleData = require('redux/modules/moduleData');

var moduleActions = _interopRequireWildcard(_moduleData);

var _modules = require('redux/modules/modules');

var _reactRouter = require('react-router');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://www.kirupa.com/react/transferring_properties.htm
// http://stackoverflow.com/questions/36631761/when-should-i-add-redux-to-a-react-app
var Module0App3 = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    app: state.moduleData.data.module0.app3,
    allModule: state.moduleData.data.module1
  };
}, (0, _extends3.default)({}, moduleActions, { changeItem: _modules.changeItem })), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module0App3, _Component);

  function Module0App3() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module0App3);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module0App3.__proto__ || (0, _getPrototypeOf2.default)(Module0App3)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      moduleId: 1,
      appId: 3,
      isCompleted: _this.props.app.isCompleted || false,
      types: {
        app: 0,
        extra: 1,
        activity: 2
      }
    }, _this.handleChange = function (str, event) {
      var obj = _this.state;
      obj[str] = event.target.value;
      _this.setState(obj);
    }, _this.handleComplete = function () {
      var obj = _this.state;
      var numAppCompleted = _this.props.allModule.numAppCompleted;

      // if its not completed, we increase numAppCompleted
      if (!obj.isCompleted) {
        numAppCompleted++;
      }

      obj.isCompleted = true;
      _this.setState(obj);

      // update the actual app
      // this.props.updateModuleApp(this.props.user.userId, this.state.moduleId, this.state.appId, this.state);
      _this.props.updateModuleApp(_this.props.user.userId, 0, 3, _this.state);

      // update the overarching module's details
      _this.props.updateModule(_this.props.user.userId, _this.state.moduleId, {
        'numAppCompleted': numAppCompleted,
        'numAppTotal': _this.props.allModule.numAppTotal });

      _this.props.changeItem(_this.state.moduleId, 0, _this.state.appId + 1);
    }, _this.handleOnClick = function (module, modtype, item, event) {
      event.preventDefault();
      _this.props.changeItem(module, modtype, item);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  // for each yes/no answer
  // we split into a string and a boolean
  // because if the string is empty, it means we haven't picked
  // a value yet
  // but we always initialise the boolean to false
  // so there are actually 3 states
  // seen: empty, isSeen: false
  // seen: notempty, isSeen: false
  // seen: notempty, isSeen: true


  /*
   * User types in something for what was
   * involved in the diet
   */


  /*
   * Handle when user finishes this module
   */


  // used to navigate to a resource item


  (0, _createClass3.default)(Module0App3, [{
    key: 'render',
    value: function render() {
      var styles = require('../../Modules.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.activityPanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              'Getting Ready'
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            'We are going to visit again what was presented in the video about the importance of healthy eating after cancer treatment. You can revisit this below along with some extra information about some interesting reesarch that has been done on children\'s eating habits and cancer treatment or skip to the next section by hitting the "Save and continue" button.'
          ),
          _react2.default.createElement(
            'h4',
            null,
            'Why is healthy eating important for children after cancer treatment?'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Children who have had cancer treatment are more likely to have long-lasting health problems as an adult. Problems such as weight gain, heart disease, diabetes, high blood pressure and cholesterol.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'By having a good intake of fruit and vegetables your child\u2019s chance of these problems happening is greatly reduced. '
          ),
          _react2.default.createElement(
            'h4',
            null,
            'Why is it important to start healthy eating habits early?'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Adult\u2019s food habits are established during childhood. It is important for your child to get used to seeing, smelling and eating vegetables during their early years when food likes and dislikes form. It is harder to change eating habits as an adult.'
          ),
          _react2.default.createElement(
            'h4',
            null,
            'Why is healthy eating difficult for children after cancer treatment?'
          ),
          _react2.default.createElement(
            'p',
            null,
            'For many children, it can lead to:'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Loss of appetite, nausea, vomiting or diarrhoea'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Taste changes'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Food aversions'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Changes in parenting'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Steroids'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Limited exposure to new foods'
              )
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/module1', onClick: this.handleOnClick.bind(this, 1, this.state.types.extra, 2) },
              ' Click here'
            ),
            ' for extra info on these difficulties and the research.'
          ),
          _react2.default.createElement(
            'h4',
            null,
            'Why is eating ',
            _react2.default.createElement(
              'strong',
              null,
              'fruit and vegetables'
            ),
            ' important for children after cancer treatment?'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Heart-related diseases are the third most common serious health problem in adult survivors of childhood cancer. However, survivors are less likely to develop heart disease if they eat plenty of fruit and vegetables as they are great sources of:'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Vitamins (e.g. A, B-vitamins and C) and minerals (e.g. magnesium and potassium) - important for keeping our bodies healthy'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Phytonutrients \u2013 give fruits and vegetables their unique colours and can reduce disease risk'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Fibre \u2013 important for a healthy gut'
              )
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            'When we eat fruits and vegetables, we also tend to eat less fat, sugar and salt, especially from processed foods.'
          )
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement(_components.FinishTaskButton, { onChange: this.handleComplete })
      );
    }
  }]);
  return Module0App3;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  app: _propTypes2.default.object,
  allModule: _propTypes2.default.object,
  updateModuleApp: _propTypes2.default.func,
  updateModule: _propTypes2.default.func,
  changeItem: _propTypes2.default.func
}, _temp2)) || _class);
exports.default = Module0App3;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/0/App/App3.js
// module id = 1155
// module chunks = 0